export function deleteAndShift(object: any, key: number) {
  delete object[`index-${key}`];
  while (`index-${++key}` in object) {
    object[`index-${key - 1}`] = object[`index-${key}`];
    delete object[`index-${key}`];
  }
  return object;
}
